import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { requestPasswordReset } from '../../services/authService';
import '../../styles/forms/forgotPassword.css';

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('이메일 발송되었습니다. 유효시간(30분) 이내에 1회 접속 가능합니다.');
  const emailInputRef = useRef(null);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (errors.email) {
      setErrors({});
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 이메일 유효성 검사
    if (!email) {
      setErrors({ email: 'Email is required' });
      emailInputRef.current?.focus();
      return;
    } else if (!validateEmail(email)) {
      setErrors({ email: 'Please enter a valid email address' });
      emailInputRef.current?.focus();
      return;
    }

    setIsLoading(true);
    
    try {
      // 비밀번호 초기화 API 호출
      const response = await requestPasswordReset(email);
      // 응답 메시지가 있으면 사용, 없으면 기본 메시지 사용
      if (response.message) {
        setSuccessMessage(response.message);
      }
      setShowSuccessModal(true);
    } catch (error) {
      console.error('비밀번호 초기화 요청 실패:', error);
      setErrors({
        general: error.userMessage || '비밀번호 초기화 요청에 실패했습니다. 잠시 후 다시 시도해주세요.'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    onBack(); // 로그인 페이지로 돌아가기
  };

  return (
    <div className="forgot-password-wrapper">
      <div className="forgot-password-form">
        <h2 className="forgot-password-title">Reset Your Password</h2>
        
        {errors.general && (
          <div className="auth-error">{errors.general}</div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email address"
              value={email}
              onChange={handleChange}
              ref={emailInputRef}
              className={errors.email ? 'error-input' : ''}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>
          
          <button 
            type="submit" 
            className="reset-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
          
          <button 
            type="button" 
            onClick={onBack} 
            className="back-button"
          >
            Back to Login
          </button>
        </form>
      </div>
      
      {showSuccessModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Password Reset Email Sent</h2>
            <p>{successMessage}</p>
            <div className="modal-buttons">
              <button 
                className="modal-button save" 
                onClick={handleCloseModal}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ForgotPassword.propTypes = {
  onBack: PropTypes.func.isRequired
};

export default ForgotPassword; 